import styled from '@emotion/styled';
import path from 'path-browserify';
import { DateTime } from 'luxon';
import * as React from 'react';
import { CardWidget } from '../../../widgets/CardWidget';
import { CardTagWidget } from '../../../widgets/CardTagWidget';
import { BlogPost, BlogPostMeta } from './blog';
import { BLOG_CATEGORY_TONES } from './blogCategories';

export interface BlogCardWidgetProps {
  post: BlogPost | BlogPostMeta;
  className?: string;
}

const isBlogPost = (post: BlogPost | BlogPostMeta): post is BlogPost => {
  return 'frontmatter' in post;
};

export const BlogCardWidget: React.FC<BlogCardWidgetProps> = (props) => {
  let frontmatter: BlogPostMeta;
  let categories: BlogPost['categories'];
  let dateTime: DateTime;

  if (isBlogPost(props.post)) {
    frontmatter = props.post.frontmatter;
    categories = props.post.categories;
    dateTime = props.post.date;
  } else {
    frontmatter = props.post;
    categories = Array.isArray(frontmatter.category) ? frontmatter.category : [frontmatter.category].filter(Boolean);
    dateTime = DateTime.fromSQL(frontmatter.created ?? frontmatter.date);
  }

  const primaryCategory = categories[0];
  const publishedDate = dateTime.isValid ? dateTime.toFormat('MMM d, yyyy') : frontmatter.date;

  return (
    <CardWidget
      className={props.className}
      href={frontmatter.permalink}
      cover={{ src: path.join(frontmatter.permalink, frontmatter.cover_image) }}
      title={frontmatter.title}
      description={frontmatter.description}
      metadata={
        <>
          {primaryCategory ? (
            <CardTagWidget $tone={BLOG_CATEGORY_TONES[primaryCategory]}>{primaryCategory}</CardTagWidget>
          ) : null}
          <S.Date>{publishedDate}</S.Date>
        </>
      }
    />
  );
};
namespace S {
  export const Date = styled.div`
    color: ${(p) => p.theme.text.paragraph};
    font-size: 13px;
    opacity: 0.85;
  `;
}
